<script>
	import { page } from '$app/stores';
	import { dev } from '$app/environment';

	$: error = $page.error
	$: status = getMessage(error.status)

	$: console.error(error)

	function getMessage(status) {
		switch (status) {
			case 404:
				return 'Eltévedtél?';
			default:
				return 'Valami hiba történt. Próbáld meg frissíteni a lapot.';
		}
	}
</script>

<svelte:head>
	<title>{status}</title>
</svelte:head>

<main>
	<div>
		<h2>{status}</h2>
		<p>{error.message}</p>
		<a href="/">Vissza a főoldalra</a>
	</div>
	{#if status >= 500 && error.stack}
		<details open={dev}>
			<summary>Részletek</summary>
			<pre>{error.stack}</pre>
		</details>
	{/if}
</main>

<style>
	main {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		text-align: center;
		flex-direction: column;
	}

	p {
		margin: 0;
	}

	h2 {
		background: var(--gradient-10);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-size: var(--font-size-8);
	}
	pre {
		text-align: left;
		overflow: hidden;
		overflow-wrap: break-word;
		word-break: break-all;
		text-overflow: ellipsis;
		max-width: 97vw;
	}
</style>
